module.exports = __webpack_public_path__ + "img/14.2867a8fc.jpg";